import { merge, find } from 'lodash'
import { PortModel, DefaultLinkModel } from 'mrblenny-storm-react-diagrams'

export class CustomPortModel extends PortModel {
  serialize() {
    return merge(super.serialize(), {})
  }

  createLinkModel = () => new DefaultLinkModel()

  canLinkToPort(port) {
    const ports = [port, this]
    const inputPort = find(ports, ['type', 'input'])
    const outputPort = find(ports, ['type', 'output'])
    // Port type must differ. i.e. input -> output
    const isInputToOutput = inputPort && outputPort
    // Output can only go to 1 input
    const isOutputToSingleInput = outputPort && Object.keys(outputPort.links).length === 1

    if (isOutputToSingleInput && isInputToOutput) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/CustomNode/CustomPortModel.js